export default {
    CARD: 'card',
};



// WEBPACK FOOTER //
// ./src/menu-management/itemTypes.js